import {MemberEntityModel} from "../../member-entity.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {AfterViewInit, Component} from "@angular/core";
import {FormControl} from "@angular/forms";
import {EditMode} from "../../../../framework/entity/edit/edit-page/edit-mode";

@Component({
    selector: "wbo-member-edit-details",
    templateUrl: "./member-edit-details.component.html"
})
export class MemberEditDetailsComponent implements AfterViewInit {

    EditMode = EditMode;

    constructor(public model: MemberEntityModel, public editService: EditService) {
    }

    get memberNoAuto(): boolean {
        if (this.model.data.memberNoAuto == null) {
            this.model.data.memberNoAuto = true;
        }
        return this.model.data.memberNoAuto;
    }

    set memberNoAuto(_memberNoAuto: boolean) {
        this.model.data.memberNoAuto = _memberNoAuto;
        this.editService.formGroup.get("memberNo").reset(null);

    }

    ngAfterViewInit() {
        this.editService.formGroup.addControl("memberNoAuto", new FormControl());
    }
}
